export default {
    setArticles(state, data) {
        state.articles = data
    },
    setArticle(state, data) {
        state.article = data
    }
}
